<template>
	<div class="outerWrapper">
		<div class="skillsHeader">
			<h4>Your Skillset</h4>
			<div class="skillsFilter">
				<span :class="{ active: skillFilter === 'all' }" @click="skillFilter = 'all'">all</span>
				<span :class="{ active: skillFilter === 'soft' }" @click="skillFilter = 'soft'">soft</span>
				<span :class="{ active: skillFilter === 'hard' }" @click="skillFilter = 'hard'">hard</span>
			</div>
			<span class="skillBlurb" v-if="skillFilter !== 'all'">
				<i class="fas fa-info"></i>
				<p>
					{{
						skillFilter === 'soft'
							? 'Soft skills are typically interpersonal “people” skills or desirable personality traits that revolve around character, teamwork, communication, and work ethic.'
							: 'Hard skills are taught skills. They are quantifiable and are often learned in school, through certifications, or in previous work experience.'
					}}
				</p>
			</span>
		</div>
		<div class="wrapper">
			<div id="skillsCloud" ref="skillsCloud"></div>
		</div>
	</div>
</template>

<script>
import WordCloud from 'wordcloud';
export default {
	name: 'SkillsCloud',
	data() {
		return {
			skillFilter: 'all', // or 'soft' or 'hard'
		};
	},
	props: {
		skills: {
			type: Object,
		},
	},
	computed: {
		compiledSkills: function() {
			const skills = this.skills || this.retrieveSkills() || [];
			let skillSet = [];
			const softSkills = skills.soft || [];
			const hardSkills = skills.hard || [];

			if (this.skillFilter === 'all') {
				skillSet = skillSet.concat(softSkills).concat(hardSkills);
			} else if (this.skillFilter === 'soft') {
				skillSet = softSkills;
			} else {
				skillSet = hardSkills;
			}
			return skillSet.map(skill => {
				return [skill.skill, skill.count];
			});
		},
	},
	watch: {
		skillFilter: function() {
			this.createSkillCloud(this.compiledSkills);
		},
	},
	methods: {
		createSkillCloud(list) {
			const randInt = () => Math.floor(Math.random() * Math.floor(4));
			const colors = ['#3193C1', '#E0A42E', '#35A88C', '#8C4DBE'];
			const options = {
				list,
				weightFactor: x => x * 20,
				minSize: 5,
				color: () => colors[randInt()],
				shape: 'square',
				backgroundColor: 'transparent',
				shrinkToFit: true,
				fontFamily: 'Open Sans',
				fontWeight: 600,
				minRotation: 0,
				maxRotation: 0,
				gridSize: 20,
				classes: 'cloudSkill',
			};

			WordCloud(this.$refs.skillsCloud, options);
		},
		storeSkills: function(skills) {
			localStorage.setItem('skills', JSON.stringify(skills));
		},
		retrieveSkills: function() {
			return JSON.parse(localStorage.getItem('skills'));
		},
	},
	mounted() {
		this.createSkillCloud(this.compiledSkills);
		if (this.skills) {
			this.storeSkills(this.skills);
		}
	},
};
</script>

<style lang="less" scoped>
.outerWrapper {
	box-shadow: 0px -0.465507px 5.12058px rgba(62, 121, 160, 0.0282725),
		0px -1.56354px 17.199px rgba(62, 121, 160, 0.0417275);
}
.skillBlurb {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	text-align: center;
	margin-top: 6px;
	align-items: center;
	background-color: #edf2f5;
	padding: 3px 6px;
	border-radius: 3px;
	i {
		margin: 0 12px;
		font-size: 1.5em;
	}
	p {
		padding: 3px 12px;
		margin: 0;
		font-size: 1em;
		text-align: left;
		line-height: 1.4em;
	}
}
.wrapper {
	display: block;
	width: 100%;
	box-sizing: border-box;
	padding: 2em;
	background: #ffffff;
}
#skillsCloud {
	width: 100%;
	height: 300px;
}
.skillsHeader {
	padding: 9px;
	box-sizing: border-box;
	background-color: white;
	position: relative;
	h4 {
		background-color: #2aacea;
		color: white;
		text-transform: none;
		letter-spacing: normal;
		font-size: 1.25em;
		font-weight: 600;
		padding: 1.25em 2em;
		margin: 0;
		border-radius: 3px;
	}
	.skillsFilter {
		position: absolute;
		top: 24px;
		right: 24px;
		background-color: white;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-items: center;
		box-sizing: border-box;
		overflow: hidden;
		color: #1f344c;
		padding: 2px;
		border-radius: 3px;
		@media screen and (max-width: 375px) {
			display: none;
		}
		span {
			padding: 3px 9px;
			cursor: pointer;
			text-transform: uppercase;
			font-weight: 600;
			font-size: 0.9em;
			border-radius: 3px;
			&.active {
				background-color: #0479b2;
				color: white;
			}
		}
	}
}
</style>

<style lang="less">
span.cloudSkill {
	opacity: 0.75;
	transition: 100ms;
	cursor: default;
	&:hover {
		opacity: 1;
	}
}
</style>
